import { FC, useEffect } from 'react';
import {
	Flex,
	Modal,
	ModalBody,
	ModalContent,
	ModalOverlay,
	ModalCloseButton,
} from 'src/components/ui';
import { Integrations } from 'src/pages';

interface ICampaignSuccessModalProps {
	isOpen: boolean;
	onClose: () => void;
	redirectedFromFB: boolean;
}

const IntegrationsModal: FC<ICampaignSuccessModalProps> = ({
	isOpen,
	onClose,
	redirectedFromFB,
}) => {
	useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [isOpen]);

	return (
		<Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={true}>
			<ModalOverlay zIndex={1800} />
			<ModalContent my="auto" maxW="600px" containerProps={{ zIndex: 1900 }}>
				<ModalCloseButton />
				<ModalBody
					bgColor="transparent"
					display="flex"
					flexDirection="column"
					alignItems="center"
					pt={6}
					pb={10}
					css={{
						'&::-webkit-scrollbar': {
							width: '8px',
							backgroundColor: '#F5F5F5',
							visibility: 'visible',
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: '#888',
							borderRadius: '4px',
						},
						'&::-webkit-scrollbar-thumb:hover': {
							backgroundColor: '#555',
						},
						overflowY: 'auto',
						maxHeight: '90vh',
					}}
				>
					<Flex direction="column" gap={8} w="full" alignItems="center">
						<Integrations
							redirectedFromFB={redirectedFromFB}
							isCampaignContext={true}
						/>
					</Flex>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default IntegrationsModal;
